import React from "react";
import { Route } from "react-router-dom";
import Scheduling from "../../AdminDashboard/Scheduling/Scheduling";
import AssignLeads from "../../AdminDashboard/Scheduling/AssignLeads/AssignLeads";
import All from "../../AdminDashboard/Scheduling/All/All";
import Messages from "../../AdminDashboard/Scheduling/Messages/Messages";
import NewFile from "../../AdminDashboard/Scheduling/NewFile/NewFile";
import DocsPending from "../../AdminDashboard/Scheduling/DocsPending/DocsPending";
import CallBack from "../../AdminDashboard/Scheduling/CallBack/CallBack";
import CallIndia from "../../AdminDashboard/Scheduling/CallIndia/CallIndia";
import DocsReviewed from "../../AdminDashboard/Scheduling/DocsReviewed/DocsReviewed";
import PaymentTrying from "../../AdminDashboard/Scheduling/PaymentTrying/PaymentTrying";
import PaymentRecieved from "../../AdminDashboard/Scheduling/PaymentRecieved/PaymentRecieved";
import VoiceMail from "../../AdminDashboard/Scheduling/VoiceMail/VoiceMail";
import NotInterested from "../../AdminDashboard/Scheduling/NotInterested/NotInterested";
import PositiveCall from "../../AdminDashboard/Scheduling/PositiveCall/PositiveCall";
import Resolve from "../../AdminDashboard/Scheduling/Resolve/Resolve";
import PersonalInfoUpdated from "../../AdminDashboard/Scheduling/PersonalInfoUpdated/PersonalInfoUpdated";
import NewRegistration from "../../AdminDashboard/Scheduling/NewRegistration/NewRegistration";
import ReferalClients from "../../AdminDashboard/Scheduling/ReferalClients/ReferalClients";
import WrongNumber from "../../AdminDashboard/Scheduling/WrongNumber/WrongNumber";
import EmailIncorrect from "../../AdminDashboard/Scheduling/EmailIncorrect/EmailIncorrect";
import UsCitizens from "../../AdminDashboard/Scheduling/UsCitizens/UsCitizens";
import DoNotDisturb from "../../AdminDashboard/Scheduling/DoNotDisturb/DoNotDisturb";
import FilingNotEligible from "../../AdminDashboard/Scheduling/FilingNotEligible/FilingNotEligible";
const SchedulingRoutes = () => {
  return (
    <Route path="scheduling" element={<Scheduling />}>
      <Route path="assign-leads" element={<AssignLeads />} />
      <Route path="all" element={<All />} />
      <Route path="messages" element={<Messages />} />
      <Route path="new-file" element={<NewFile />} />
      <Route path="docs-pending" element={<DocsPending />} />
      <Route path="call-back" element={<CallBack />} />
      <Route path="resolve" element={<Resolve />} />
      <Route path="positive-call" element={<PositiveCall />} />
      <Route path="call-india" element={<CallIndia />} />
      <Route path="docs-reviewed" element={<DocsReviewed />} />
      <Route path="personal-info-updated" element={<PersonalInfoUpdated />} />
      <Route path="new-registration" element={<NewRegistration />} />
      <Route path="referal-clients" element={<ReferalClients />} />
      <Route path="payment-trying" element={<PaymentTrying />} />
      <Route path="payment-recieved" element={<PaymentRecieved />} />
      <Route path="voice-mail" element={<VoiceMail />} />
      <Route path="not-interested" element={<NotInterested />} />
      <Route path="wrong-number" element={<WrongNumber />} />
      <Route path="email-incorrect" element={<EmailIncorrect />} />
      <Route path="us-citizens" element={<UsCitizens />} />
      <Route path="do-not-disturb" element={<DoNotDisturb />} />
      <Route path="filing-not-eligible" element={<FilingNotEligible />} />
    </Route>
  );
};

export default SchedulingRoutes;
